import { render, staticRenderFns } from "./DimentionsProductCard.vue?vue&type=template&id=7524af10&"
import script from "./DimentionsProductCard.vue?vue&type=script&lang=js&"
export * from "./DimentionsProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports